import { useState } from 'react'
import {
  List,
  SimpleForm,
  Button as ButtonR,
  TextInput,
  Datagrid,
  Edit,
  Create,
  TextField,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  useRefresh,
  useNotify,
  useDataProvider,
  Toolbar,
  ArrayField,
} from 'react-admin'
import { makeStyles } from '@material-ui/core/styles'
import { EmptyActions, ExtraPagination } from './utils'
import Chip from '@material-ui/core/Chip'
import DeleteIcon from '@mui/icons-material/Delete'
import { Button } from '@material-ui/core'

//Same hack than in external_ags to make save function override work
const SimpleFormWrapper = (props) => {
  const { save, submit, ...rest } = props
  return <SimpleForm save={submit} variant="outlined" {...rest} />
}

export const RoutingAiKeywordCreate = (props) => {
  const dataProvider = useDataProvider()
  const notify = useNotify()
  const [keywords, setKeywords] = useState([])

  //NOTE: we have to use a PUT endpoint so that RA dataprovider returns the full
  //API response (if we use a POST, it returns the sent payload with an id)
  const createQuery = (record, redirect) => {
    dataProvider
      .update('routing_ai_keywords', { id: 1, data: record })
      .then((response) => {
        console.log(response)
        setKeywords(response.data.results.body)
      })
      .catch((error) => {
        console.log(error.message)
        alert(error.message)
        notify(error.message, 'warning')
      })
  }

  return (
    <div>
      <SimpleFormWrapper
        variant="outlined"
        redirect={false}
        submit={createQuery}
        resource="routing_ai_keywords"
        defaultValues={{ results: [] }}
        basePath="/"
      >
        <ReferenceInput
          label="Tag"
          source="tag_id"
          reference="front_tags"
          variant="outlined"
        >
          <SelectInput optionText="name" />
        </ReferenceInput>
      </SimpleFormWrapper>
      <div>
        <ArrayField record={keywords} source="keywords" label="keywords">
          <Datagrid>
            <TextField source="keyword" label="keyword" />
            <TextField source="score" label="score" />
          </Datagrid>
        </ArrayField>
      </div>
    </div>
  )
}
